import React, { createContext, useContext, useMemo } from 'react';

import {
  fetchAbout,
  fetchExperience,
  fetchProject,
  fetchProjects,
} from '../services/api';

export type ContentfulFetchers = {
  fetchAbout: typeof fetchAbout;
  fetchExperience: typeof fetchExperience;
  fetchProjects: typeof fetchProjects;
  fetchProject: typeof fetchProject;
};

const defaultFetchers: ContentfulFetchers = {
  fetchAbout,
  fetchExperience,
  fetchProjects,
  fetchProject,
};

const ContentfulContext = createContext<ContentfulFetchers | null>(null);

type ContentfulProviderProps = {
  children: React.ReactNode;
  fetchers?: Partial<ContentfulFetchers>;
};

export function ContentfulProvider({ children, fetchers }: ContentfulProviderProps) {
  const value = useMemo(
    () => ({ ...defaultFetchers, ...fetchers }),
    [fetchers]
  );

  return <ContentfulContext.Provider value={value}>{children}</ContentfulContext.Provider>;
}

export function useContentfulFetchers(): ContentfulFetchers {
  const ctx = useContext(ContentfulContext);
  if (!ctx) {
    throw new Error('Contentful hooks must be used within ContentfulProvider');
  }
  return ctx;
}
